import { Text } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { RocketLine } from "@dropbox/dig-icons/assets";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import { PAP_Select_DashSetupModuleWelcomeVideo } from "@mirage/analytics/events/types/select_dash_setup_module_welcome_video";
import { useOnHideClick } from "@mirage/growth/onboarding/setup-module/shared/useOnHideClick";
import { Link } from "@mirage/link/Link";
import { useOnboardingValues } from "@mirage/service-onboarding/hooks";
import { openURL } from "@mirage/service-platform-actions";
import { HELP_CENTER } from "@mirage/shared/urls";
import i18n, { Trans } from "@mirage/translations";
import GetStartedImage from "./assets/get_started_thumbnail.svg";
import { ModuleItemContainer } from "./shared/ModuleItemContainer";
import { useSetupModuleShown } from "./shared/useSetupModuleShown";
import styles from "./styles.module.css";

// This URL is temporary and will be replaced with the final URL
// when the video is ready in OGROW-2151
export const GET_STARTED_VIDEO_URL =
  "https://learn.dropbox.com/video-library/dropbox-dash-overview";

export const GetStartedModuleItem: React.FC = () => {
  const { onboardingValues, setOnboardingValue } = useOnboardingValues();
  const { reportPapEvent } = useMirageAnalyticsContext();
  const onHideClick = useOnHideClick("get_started");
  useSetupModuleShown(
    "get_started",
    !!onboardingValues?.dismissedSetupModuleGetStarted,
  );

  const handleOnHideClick = () => {
    onHideClick(
      <Trans
        i18nKey={"setup_module_hide_get_started"}
        components={{
          buttonLink: <Link variant="monochromatic" href={HELP_CENTER} />,
        }}
      />,
    );
    setOnboardingValue("dismissedSetupModuleGetStarted", true);
  };

  const handleOnClick = () => {
    reportPapEvent(
      PAP_Select_DashSetupModuleWelcomeVideo({
        featureLine: "onboarding",
      }),
    );
    openURL(GET_STARTED_VIDEO_URL);
  };

  if (onboardingValues?.dismissedSetupModuleGetStarted) {
    return null;
  }

  return (
    <ModuleItemContainer
      label={i18n.t("setup_module_get_started_title")}
      leftAccessory={RocketLine}
      onHideClick={handleOnHideClick}
      data-testid="setup-module-get-started"
    >
      <Box
        alignItems="center"
        borderRadius="Medium"
        className={styles.getStartedContentContainer}
        display="flex"
        backgroundColor="Background Subtle"
        onClick={handleOnClick}
        paddingX="Micro XLarge"
        paddingY="Micro Large"
      >
        <img
          src={GetStartedImage}
          className={styles.getStartedImage}
          alt={i18n.t("setup_module_get_started_content_alt")}
        />
        <div>
          <Text size="large" isBold>
            {i18n.t("setup_module_get_started_content_title")}
          </Text>
          <Text className={styles.colorSecondary} tagName="p">
            {i18n.t("setup_module_get_started_content_description")}
          </Text>
        </div>
      </Box>
    </ModuleItemContainer>
  );
};
